/** @format */

import { Button, Card, Progress, Statistic } from "antd";
import { useHistory } from "react-router";

type CardStatistikProps = {
  title: string;
  valuePrimary: number;
  prefix: string;
  persent?: number;
  titleSecondary?: string;
  valueSecondary?: number;
  type?: "indikatif" | "definitif";
  loading?: boolean;
};

export const CardStatistik = ({
  title,
  valuePrimary,
  valueSecondary,
  titleSecondary,
  prefix,
  loading,
}: CardStatistikProps) => {
  return (
    <Card className="flex-1 text-center " bodyStyle={{ height: "100%" }}>
      <div className="flex gap-4 justify-between h-full flex-col">
        <div className="flex-1">
          <h2 className="text-xl">{title}</h2>
          <Statistic
            title=""
            value={valuePrimary}
            prefix={prefix}
            valueStyle={{ fontSize: 20, fontWeight: "bold" }}
            loading={loading}
          />
        </div>
        {titleSecondary && valueSecondary !== undefined && (
          <div className="flex-1">
            <h2 className="text-xl">{titleSecondary}</h2>
            <Statistic
              title=""
              value={valueSecondary}
              prefix={prefix}
              valueStyle={{ fontSize: 20, fontWeight: "bold" }}
              loading={loading}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export const CardStatistikProgress = ({
  title,
  valuePrimary,
  prefix,
  persent,
  valueSecondary,
  loading,
}: CardStatistikProps) => {
  return (
    <Card className="flex-1 text-center">
      <div className="p-2">
        <h2 className="text-xl">{title}</h2>
        <Progress type="circle" percent={persent} gapDegree={100} />
        <div className="flex">
          <div className="flex-1">
            <Statistic
              title="Anggaran"
              value={valuePrimary}
              prefix={prefix}
              valueStyle={{ fontSize: 12 }}
              loading={loading}
            />
          </div>
          <div className="flex-1">
            <Statistic
              title="Realisasi"
              value={valueSecondary}
              prefix={prefix}
              valueStyle={{ fontSize: 12 }}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export const CardStatistikDetail = ({
  title,
  valuePrimary,
  valueSecondary,
  loading,
  type,
}: CardStatistikProps) => {
  const route = useHistory();

  return (
    <Card className="flex-1">
      <div className="flex gap-4 justify-center  items-center h-full">
        <div className="flex-1 text-center p-5">
          <Statistic
            title={`${title} Selesai`}
            value={valuePrimary}
            valueStyle={{ fontSize: 24, fontWeight: "bold" }}
            loading={loading}
          />
          <div className="py-4">
            <Button
              type="primary"
              onClick={() =>
                route.push({
                  pathname:
                    type === "indikatif"
                      ? "/dashboard-indikatif/details"
                      : "/dashboard/details",
                  state: {
                    title: `${title} Selesai`,
                    status:
                      title === "Rencana"
                        ? "Rencana Selesai"
                        : "REALISASI SELESAI",
                    type: title.toLowerCase(),
                    pagu: type,
                  },
                })
              }
              block>
              Lihat Detail
            </Button>
          </div>
        </div>
        <div className="flex-1 text-center p-5">
          <Statistic
            title={`${title} Belum Selesai`}
            value={valueSecondary}
            valueStyle={{ fontSize: 24, fontWeight: "bold" }}
            loading={loading}
          />
          <div className="py-4">
            <Button
              type="primary"
              onClick={() =>
                route.push({
                  pathname:
                    type === "indikatif"
                      ? "/dashboard-indikatif/details"
                      : "/dashboard/details",
                  state: {
                    title: `${title} Belum Selesai`,
                    status:
                      title === "Rencana"
                        ? "Rencana Belum Selesai"
                        : "REALISASI BELUM SELESAI",
                    type: title.toLowerCase(),
                    pagu: type,
                  },
                })
              }
              block>
              Lihat Detail
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
};
